export default __webpack_public_path__ + "static/daehan_realestate_trust-e7e551f421c8fa38d531d31ddb28024e.png";